import React from 'react';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import BusinessIcon from '@material-ui/icons/Business';
import AssessmentIcon from '@material-ui/icons/Assessment';
import RoomIcon from '@material-ui/icons/Room';
import SettingsIcon from '@material-ui/icons/Settings';
import ChatIcon from '@material-ui/icons/Chat';
import ResourceIcon from '@material-ui/icons/EmojiObjects';
import BillingIcon from '@material-ui/icons/Payment.js';
import * as Permissions from '../../../lib/permissions';

const pages = {
  profile: {
    path: 'profile',
    permission: Permissions.editProvider,
    icon:  <BusinessIcon />,
    label: 'Profile',
  },
  listings: {
    path: 'listings',
    permission: Permissions.editListings,
    icon:  <LocalOfferIcon />,
    label: 'Listings',
  },
  premises: {
    path: 'premises',
    permission: Permissions.editProvider,
    icon:  <RoomIcon />,
    label: 'Premises',
  },
  dashboard: {
    path: 'dashboard',
    permission: Permissions.viewAnalytics,
    icon:  <AssessmentIcon />,
    label: 'Dashboard',
  },
  reviews: {
    path: 'reviews',
    permission: Permissions.createReviewResponses,
    icon:  <ChatIcon />,
    label: 'Reviews',
  },
  users: {
    path: 'users',
    permission: Permissions.editUserRoles,
    icon:  <PeopleAltIcon />,
    label: 'Users',
  },
  billing: {
    path: 'billing',
    permission: 'hide-until-billing-release', // Permissions.editBilling,
    icon:  <BillingIcon />,
    label: 'Billing',
    divider: true,
  },
  resources: {
    path: 'resources',
    permission: null,
    icon:  <ResourceIcon />,
    label: 'Resources',
    divider: true,
  },
  settings: {
    path: 'settings',
    permission: 'Site Admin',  // use any string that isn't a real permission
    icon: <SettingsIcon />,
    label: 'Settings',
    divider: true,
  }
};

export default pages;
